import { useEffect, useState } from 'react';

export default function InstallAppPrompt() {
  const [installEvent, setInstallEvent] = useState(null);
  const [visible, setVisible] = useState(false);
  const [isIos, setIsIos] = useState(false);

  useEffect(() => {
    const mobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const standalone = window.matchMedia('(display-mode: standalone)').matches || navigator.standalone;
    const dismissed = sessionStorage.getItem('konnectt-install-dismissed');
    const ios = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    setIsIos(ios);

    const handlePrompt = (event) => {
      event.preventDefault();
      setInstallEvent(event);
      if (mobile && !standalone && !dismissed) setVisible(true);
    };

    window.addEventListener('beforeinstallprompt', handlePrompt);
    if (mobile && ios && !standalone && !dismissed) setVisible(true);
    return () => window.removeEventListener('beforeinstallprompt', handlePrompt);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem('konnectt-install-dismissed', 'true');
    setVisible(false);
  };

  const install = async () => {
    if (!installEvent) return;
    installEvent.prompt();
    await installEvent.userChoice;
    setVisible(false);
    setInstallEvent(null);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-4 bottom-4 z-[100] mx-auto max-w-sm rounded-2xl bg-slate-900 p-4 text-white shadow-2xl" role="dialog" aria-label="Install Konnectt">
      <button className="absolute right-3 top-2 text-xl text-slate-300" onClick={dismiss} aria-label="Close">×</button>
      <p className="pr-5 font-semibold">Install Konnectt</p>
      <p className="mt-1 text-sm text-slate-300">
        {isIos ? 'Tap Share, then “Add to Home Screen” to use Konnectt like an app.' : 'Add Konnectt to your home screen for the app experience.'}
      </p>
      {!isIos && <button onClick={install} className="mt-3 rounded-lg bg-white px-4 py-2 text-sm font-semibold text-slate-900">Install app</button>}
    </div>
  );
}
